export default {
  "home/link-git": {
    en: "Source code & feedback",
    fr: "Code source & retours",
  },

  "home/connect": {
    en: "Connect",
    fr: "Connecter",
  },

  "home/challenges": {
    en: "Incoming Challenges",
    fr: "Défis",
  },

  "home/challenge-accept": {
    en: "Accept",
    fr: "Accepter",
  },

  "home/challenge-decline": {
    en: "Decline",
    fr: "Décliner",
  },

  "home/challenge-wait": {
    en: "Waiting to be challenged…",
    fr: "En attente d'un défi…",
  },
};
